import {
  useEffect,
  useState
} from "react";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getCustomers
} from "../../api/customerApi";

import {
  getProducts
} from "../../api/productApi";

import {
  createSalesOrder
} from "../../api/salesOrderApi";

import {
  FaPlus,
  FaTrash,
  FaShoppingCart,
  FaSave
} from "react-icons/fa";

const SalesOrders = () => {

  const [customers,setCustomers] =
  useState([]);

  const [products,setProducts] =
  useState([]);

  const [form,setForm] =
  useState({

    customer_id:"",
    order_date:
    new Date()
    .toISOString()
    .split("T")[0],

    delivery_date:"",
    remarks:""

  });

  const [items,setItems] =
  useState([

    {
      product_id:"",
      quantity:"",
      rate:""
    }

  ]);

  useEffect(()=>{

    loadData();

  },[]);

  const loadData =
  async()=>{

    try{

      const customerRes =
      await getCustomers();

      const productRes =
      await getProducts();

      setCustomers(
        customerRes.data.data || []
      );

      setProducts(
        productRes.data.data || []
      );

    }
    catch(error){

      console.log(error);

    }

  };

  const addRow =
  ()=>{

    setItems([

      ...items,

      {
        product_id:"",
        quantity:"",
        rate:""
      }

    ]);

  };

  const removeRow =
  (index)=>{

    const updated =
    [...items];

    updated.splice(
      index,
      1
    );

    setItems(updated);

  };

  const updateRow =
  (
    index,
    field,
    value
  )=>{

    const updated =
    [...items];

    updated[index][field] =
    value;

    setItems(updated);

  };

  const totalAmount =
  items.reduce(

    (
      total,
      item
    ) =>

      total +

      (
        Number(
          item.quantity || 0
        ) *

        Number(
          item.rate || 0
        )
      ),

    0

  );

  const saveOrder =
  async(e)=>{

    e.preventDefault();

    try{

      await createSalesOrder({

        ...form,

        items

      });

      alert(
        "Sales Order Created Successfully"
      );

      setItems([

        {
          product_id:"",
          quantity:"",
          rate:""
        }

      ]);

      setForm({

        customer_id:"",
        order_date:
        new Date()
        .toISOString()
        .split("T")[0],

        delivery_date:"",
        remarks:""

      });

    }
    catch(error){

      console.log(error);

      alert(
        "Failed To Save Sales Order"
      );

    }

  };

  return(

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header bg-white">

          <div className="d-flex align-items-center">

            <FaShoppingCart
              className="me-2 text-primary"
            />

            <div>

              <h5 className="mb-0">

                Sales Order

              </h5>

              <small className="text-muted">

                Create Customer Sales Orders

              </small>

            </div>

          </div>

        </div>

        <div className="card-body">

          <form
            onSubmit={saveOrder}
          >

            <div className="row mb-4">

              <div className="col-md-4">

                <label className="form-label">

                  Customer

                </label>

                <select
                  className="form-select"
                  value={
                    form.customer_id
                  }
                  onChange={(e)=>
                    setForm({

                      ...form,

                      customer_id:
                      e.target.value

                    })
                  }
                >

                  <option value="">
                    Select Customer
                  </option>

                  {
                    customers.map(
                      customer=>(

                        <option
                          key={customer.id}
                          value={customer.id}
                        >

                          {
                            customer.customer_name
                          }

                        </option>

                      )
                    )
                  }

                </select>

              </div>

              <div className="col-md-3">

                <label className="form-label">

                  Order Date

                </label>

                <input
                  type="date"
                  className="form-control"
                  value={
                    form.order_date
                  }
                  onChange={(e)=>
                    setForm({

                      ...form,

                      order_date:
                      e.target.value

                    })
                  }
                />

              </div>

              <div className="col-md-3">

                <label className="form-label">

                  Delivery Date

                </label>

                <input
                  type="date"
                  className="form-control"
                  value={
                    form.delivery_date
                  }
                  onChange={(e)=>
                    setForm({

                      ...form,

                      delivery_date:
                      e.target.value

                    })
                  }
                />

              </div>

            </div>

            <div className="mb-4">

              <label className="form-label">

                Remarks

              </label>

              <textarea
                rows="2"
                className="form-control"
                value={
                  form.remarks
                }
                onChange={(e)=>
                  setForm({

                    ...form,

                    remarks:
                    e.target.value

                  })
                }
              />

            </div>

            <div className="table-responsive">

              <table className="table table-bordered">

                <thead className="table-light">

                  <tr>

                    <th>
                      Product
                    </th>

                    <th width="150">
                      Qty
                    </th>

                    <th width="150">
                      Rate
                    </th>

                    <th width="180">
                      Amount
                    </th>

                    <th width="100">
                      Action
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {
                    items.map(

                      (
                        item,
                        index
                      )=>(

                        <tr
                          key={index}
                        >

                          <td>

                            <select
                              className="form-select"
                              value={
                                item.product_id
                              }
                              onChange={(e)=>
                                updateRow(

                                  index,

                                  "product_id",

                                  e.target.value

                                )
                              }
                            >

                              <option value="">
                                Select Product
                              </option>

                              {
                                products.map(
                                  product=>(

                                    <option
                                      key={
                                        product.id
                                      }
                                      value={
                                        product.id
                                      }
                                    >

                                      {
                                        product.product_name
                                      }

                                    </option>

                                  )
                                )
                              }

                            </select>

                          </td>

                          <td>

                            <input
                              type="number"
                              className="form-control"
                              value={
                                item.quantity
                              }
                              onChange={(e)=>
                                updateRow(

                                  index,

                                  "quantity",

                                  e.target.value

                                )
                              }
                            />

                          </td>

                          <td>

                            <input
                              type="number"
                              className="form-control"
                              value={
                                item.rate
                              }
                              onChange={(e)=>
                                updateRow(

                                  index,

                                  "rate",

                                  e.target.value

                                )
                              }
                            />

                          </td>

                          <td>

                            <strong>

                              ₹

                              {
                                (
                                  Number(
                                    item.quantity || 0
                                  ) *

                                  Number(
                                    item.rate || 0
                                  )

                                ).toFixed(2)
                              }

                            </strong>

                          </td>

                          <td>

                            {
                              items.length > 1 && (

                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={()=>
                                    removeRow(
                                      index
                                    )
                                  }
                                >

                                  <FaTrash />

                                </button>

                              )
                            }

                          </td>

                        </tr>

                      )

                    )
                  }

                </tbody>

              </table>

            </div>

            <div className="d-flex justify-content-between mt-3">

              <button
                type="button"
                className="btn btn-secondary"
                onClick={addRow}
              >

                <FaPlus />

                {" "}

                Add Product

              </button>

              <h4>

                Total :

                <span className="text-primary ms-2">

                  ₹
                  {
                    totalAmount.toFixed(2)
                  }

                </span>

              </h4>

            </div>

            <hr />

            <div className="text-end">

              <button
                type="submit"
                className="btn btn-primary btn-lg"
              >

                <FaSave />

                {" "}

                Save Sales Order

              </button>

            </div>

          </form>

        </div>

      </div>

    </MainLayout>

  );

};

export default SalesOrders;